import { render, staticRenderFns } from "./RelayClosed.vue?vue&type=template&id=039074f8&"
import script from "./RelayClosed.vue?vue&type=script&lang=ts&"
export * from "./RelayClosed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports